<template>
  <div>
    <el-table
      :stripe="stripe"
      v-show="reloadTable"
      :data="tableData"
      :row-class-name="tableRowClassName"
      @row-click="rowClick"
    >
      <template v-for="item of showColumns">
        <el-table-column
          v-if="item.dictionary"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
        >
          <template #default="scope">
            <DictionaryShow
              :type="item.dictionary"
              :value="scope.row[item.prop]"
            ></DictionaryShow>
          </template>
        </el-table-column>

        <template v-else-if="item.slot">
          <el-table-column
            :key="item.prop + 'slot'"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
            <template #default="scope">
              <slot :name="item.slot" :row="scope.row"></slot>
            </template>
          </el-table-column>
        </template>
        <el-table-column
          v-else
          :key="item.prop + 'default'"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
        >
          <template #default="scope">
            {{
              item.formatTime
                ? dateFormat(scope.row[item.prop])
                : scope.row[item.prop] || '/'
            }}
          </template>
        </el-table-column>
      </template>
    </el-table>

    <div v-if="showPage" class="pagination-margin-top">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :pager-count="5"
        @size-change="changePageSize"
        @current-change="changePage"
        :current-page="pager.curPage"
        :page-size="pager.pageSize"
        :total="pager.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { commonRequest } from '@/services/baseRequst.js'
import { dateFormat } from '@/utils/utils.js'
export default {
  name: 'ZKtecoTable',
  props: {
    stripe: {
      type: Boolean,
      default: true
    },
    rowClassFn: {
      type: Function,
      default: function() {
        return function(row, index) {
          return ''
        }
      }
    },
    columns: {
      type: Array,
      default: function() {
        return []
      }
    },
    tableId: {
      type: String,
      default: ''
    },
    queryParams: {
      type: Object,
      default: function() {
        return {}
      }
    },
    loadCallback: {
      type: Function,
      default: function(data) {
        let payloadData = data.payload
        if (payloadData.totalRecords !== undefined) {
          return {
            tableData: payloadData.results,
            pager: {
              total: payloadData.totalRecords,
              //   curPage: data.curPage,
              pageSize: payloadData.pageSize
            }
          }
        } else {
          return payloadData.results
        }
      }
    },
    showPage: {
      type: Boolean,
      default: true
    },
    buildQueryParams: {
      type: Function,
      default: function(data) {
        return data
      }
    },
    beforeLoad: {
      type: Function,
      default: () => {
        return true
      }
    },
    dataUrl: {
      type: String,
      default: ''
    },
    autoLoad: {
      // 默认自动加载
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      reloadTable: true,
      tableData: [],
      checkList: [],
      showList: []
    }
  },

  computed: {
    showColumns() {
      if (this.showList.length === 0 || !this.selectRowShow) {
        return this.columns.filter(item => {
          if (item.show === undefined || item.show) {
            return true
          } else {
            return false
          }
        })
      } else {
        return this.columns.filter(item => {
          if (this.showList.indexOf(item.prop) > -1) {
            return true
          } else {
            return false
          }
        })
      }
    }
  },

  mounted() {
    let select = localStorage.getItem('tableId_' + this.tableId)
    if (select) {
      this.showList = select.split(',')
      this.checkList = select.split(',')
    }
    if (this.autoLoad && this.dataUrl) {
      this.loadData()
    }
  },

  methods: {
    changePage(current) {
      this.pager.curPage = current
      this.loadData()
    },
    changePageSize(pageSize) {
      this.pager.pageSize = pageSize
      this.loadData()
    },
    dateFormat(value) {
      return dateFormat(value)
    },
    reload() {
      this.reloadTable = false
      setTimeout(() => {
        this.reloadTable = true
      }, 50)
    },
    tableRowClassName(row, index) {
      return this.rowClassFn(row, index)
    },
    rowClick(row) {
      this.$emit('row-click', row)
    },

    resetFn() {
      this.checkList.length = 0
      this.showList.length = 0
      localStorage.setItem('tableId_' + this.tableId, '')
      this.reload()
    },
    sureFn() {
      this.showList = this.checkList
      localStorage.setItem('tableId_' + this.tableId, this.showList.toString())
      this.reload()
    },

    loadData(params = {}, firstPage = false) {
      let queryParams = this.buildQueryParams(this.queryParams)
      queryParams = Object.assign(queryParams, params)
      if (firstPage) {
        this.pager.curPage = 1
      }
      if (this.showPage) {
        queryParams = {
          pager: {
            curPage: this.pager.curPage,
            pageSize: this.pager.pageSize,
            total: this.pager.total
          },
          params: queryParams
        }
      }

      let result = this.beforeLoad()
      if (!result) {
        return false
      }

      commonRequest(this.dataUrl, queryParams)
        .then(data => {
          if (data.code === '00000000') {
            if (this.loadCallback) {
              let repData = this.loadCallback(data)
              if (repData.pager) {
                this.pager.total = repData.pager.total
                this.pager.pageSize = repData.pager.pageSize
                this.tableData = repData.tableData
                if (repData.pager.curPage !== undefined) {
                  this.pager.curPage = repData.pager.curPage
                }
              } else {
                this.tableData = repData
              }
            } else {
              this.tableData = data.payload.results
            }
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(data => {
          this.errorMessage(data.message)
        })
    },

    commandFn(command) {
      if (command === 'reset') {
        this.resetFn()
      } else if (command === 'sure') {
        this.sureFn()
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/modules/comComponent/ZKtecoTable.vue